<template>
  <v-dialog
    :value="open"
    persistent
    max-width="350"
    content-class="task-item-dialog"
  >
    <v-card color="#f0f0ef" class="home-form-container">
      <v-card-text
        v-if="editedItem !== null"
        class="home-form-container"
        style="text-align: left; padding: 4px 0 0 0"
      >
        <v-layout row wrap>
          <input-field
            :label="$tc('Number', 1)"
            v-model="editedItem.bt_num_pol"
            variable-name="bt_num_pol"
            input-type="text"
            size="50"
            required
          />

          <input-field
            :label="$tc('Floor', 1)"
            v-model="editedItem.bt_floor"
            variable-name="bt_floor"
            input-type="int"
            size="50"
            required
          />

          <input-field
            :label="$tc('Fraction', 1)"
            v-model="editedItem.bt_fraction"
            variable-name="bt_fraction"
            input-type="text"
            size="50"
            required
          />

          <input-field
            :label="$tc('Type', 1)"
            v-model="editedItem.bt_type"
            variable-name="bt_type"
            input-type="select"
            selectOptions="list_bd_category_type"
            size="50"
            required
          />

          <input-field
            :label="$t('Description')"
            v-model="editedItem.bt_description"
            variable-name="bt_description"
            size="large"
            inputType="text"
          />

          <input-field
            :label="$tc('Address', 1)"
            v-model="editedItem.bt_address"
            variable-name="bt_address"
            size="large"
            inputType="text"
          />
        </v-layout>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text x-small @click="close">
          {{ $t("Cancel") }}
        </v-btn>
        <v-btn
          x-small
          color="accent"
          style="margin-right: 10px"
          @click="applyChanges"
        >
          {{ $t("ApplyChanges") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/Home/Forms/_Molecules/InputField";

export default {
  name: "TypificationEditionDialog",

  components: { InputField },

  props: {
    open: {
      type: Boolean,
      required: true
    },

    originalItem: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      editedItem: null
    };
  },

  mounted() {
    this.setItemToEdit();
  },

  watch: {
    originalItem() {
      this.setItemToEdit();
    }
  },

  methods: {
    setItemToEdit() {
      this.editedItem = Object.assign({}, this.originalItem);
    },

    applyChanges() {
      this.$emit("edit", this.editedItem);
      this.close();
    },

    close() {
      this.$emit("close");
    }
  }
};
</script>

<style>
.task-item-dialog {
  overflow-y: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Buildings/Typification/TypificationEditionDialog.vue